import React, { useState, useEffect } from 'react';
import IonIcon from '@reacticons/ionicons'; // replaced Logo with IonIcon
import './App.css';
import './Loading.css'; 

const Header = () => {
  const icons = [ "construct-outline"];
  const [iconIndex, setIconIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIconIndex(prev => (prev + 1) % icons.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <header className="App-header">
      <IonIcon name={icons[iconIndex]} size={50}  style={{ color: 'white' }} />
      <h1>Naprawa Pralek Kraków</h1>
    </header>
  );
}

export default Header;
